import { render, staticRenderFns } from "./addDispatchpersonnel.vue?vue&type=template&id=6c7fbe96&scoped=true&"
import script from "./addDispatchpersonnel.vue?vue&type=script&lang=js&"
export * from "./addDispatchpersonnel.vue?vue&type=script&lang=js&"
import style0 from "./addDispatchpersonnel.vue?vue&type=style&index=0&id=6c7fbe96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7fbe96",
  null
  
)

export default component.exports